export interface IStore {
    bizToken: string,
    failedReturnUrl: string,
    locale: string
}

const store: IStore = {
    bizToken: '',
    failedReturnUrl: '',
    locale: '',
}

export default store
